document.addEventListener('click', function (e) {
  const swatch = e.target.closest('[data-quickview-swatch]');
  if (!swatch) return;

  e.preventDefault();

  const quickview = swatch.closest('.quickview--rebuilt');
  if (!quickview) return;

  const mainImage = quickview.querySelector('.quickview__hero img');
  if (!mainImage) return;

  const fullSrc = swatch.getAttribute('data-full-src');
  const fullSrcset = swatch.getAttribute('data-full-srcset');

  if (fullSrc) {
    mainImage.src = fullSrc;
  }

  if (fullSrcset) {
    mainImage.srcset = fullSrcset;
  }

  quickview.querySelectorAll('[data-quickview-swatch]').forEach(function (item) {
    item.removeAttribute('aria-current');
  });

  swatch.setAttribute('aria-current', 'true');
});